import React from 'react';
import { Link } from 'react-router-dom';

import {
  faAndroid,
  faApple,
  faFacebookF,
  faInstagram,
  faTwitter,
  faWindows,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as IconBadgeAd } from 'bootstrap-icons/icons/badge-ad.svg';
import { ReactComponent as IconBriefcase } from 'bootstrap-icons/icons/briefcase.svg';
import { ReactComponent as IconEnvelope } from 'bootstrap-icons/icons/envelope.svg';
import { ReactComponent as IconGift } from 'bootstrap-icons/icons/gift.svg';
import { ReactComponent as IconTelephone } from 'bootstrap-icons/icons/telephone.svg';

import americanExpress from '../images/payment/american_express.webp';
import maestro from '../images/payment/maestro.webp';
import netbanking from '../images/payment/netbanking.webp';
import paypal from '../images/payment/paypal.webp';
import rupay from '../images/payment/rupay.webp';
import upi from '../images/payment/upi.webp';
import visa from '../images/payment/visa.webp';

const Footer = () => (
  <>
    <footer>
      <div className="container-fluid bg-primary">
        <div className="row ">
          <div className="col-md-9 py-3 text-white">Get connected with us on social networks!</div>
          <div className="col-md-3 py-3 text-center text-white">
            <Link to="/" title="Apple">
              <FontAwesomeIcon icon={faApple} className="text-light me-3" />
            </Link>
            <Link to="/" title="Windows">
              <FontAwesomeIcon icon={faWindows} className="text-light me-3" />
            </Link>
            <Link to="/" title="Android">
              <FontAwesomeIcon icon={faAndroid} className="text-light me-3" />
            </Link>
            |
            <Link to="/" title="Twitter">
              <FontAwesomeIcon icon={faTwitter} className="text-light ms-3 me-3" />
            </Link>
            <Link to="/" title="Facebook">
              <FontAwesomeIcon icon={faFacebookF} className="text-light me-3" />
            </Link>
            <Link to="/" title="Instagram">
              <FontAwesomeIcon icon={faInstagram} className="text-light me-3" />
            </Link>
            <Link to="/" title="Youtube">
              <FontAwesomeIcon icon={faYoutube} className="text-light me-3" />
            </Link>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-dark text-white">
        <div className="row ">
          <div className="col-md-3 py-3">
            <div className="h6">Company Name</div>
            <hr />
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
              industry&lsquo;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type
              and scrambled it to make a type specimen book.
            </p>
          </div>
          <div className="col-md-3 py-3">
            <div className="h6">Products</div>
            <hr />
            <ul className="list-group list-group-flush">
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Electronics
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Mobiles
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Car & bike
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Super Market
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Travel Cards
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-3 py-3">
            <div className="h6">Policy</div>
            <hr />
            <ul className="list-group list-group-flush">
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Return Policy
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Terms Of Use
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Security
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  Privacy
                </Link>
              </li>
              <li className="list-group-item bg-dark text-white border-light">
                <Link to="/" className="text-decoration-none text-white stretched-link">
                  EPR Compliance
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-3 py-3">
            <div className="h6">Address</div>
            <hr />
            <address>
              <strong>Twitter, Inc.</strong>
              <br />
              1355 Market St, Suite 900
              <br />
              San Francisco, CA 94103
              <br />
              <abbr title="Phone">P:</abbr> (123) 456-7890
            </address>
            <div className="h6">Customer Care</div>
            <hr />
            <IconTelephone /> +1800 100 1000
            <br />
            <IconEnvelope /> info@email.com
          </div>
        </div>
      </div>
      <div className="container-fluid bg-secondary text-white text-center">
        <div className="row">
          <div className="col-md-2 py-2">
            <Link to="/" className="text-white text-decoration-none">
              <IconBriefcase className="text-warning" /> Partner with us
            </Link>
          </div>
          <div className="col-md-2 py-2">
            <Link to="/" className="text-white text-decoration-none">
              <IconBadgeAd className="text-info" /> Advertise
            </Link>
          </div>
          <div className="col-md-2 py-2">
            <Link to="/" className="text-white text-decoration-none">
              <IconGift className="text-dark" /> Gift
            </Link>
          </div>
          <div className="col-md-3 py-2">© 2009-{new Date().getFullYear()} React-E-Commerce.com</div>
          <div className="col-md-3 py-2 bg-white">
            <img src={americanExpress} width="32" alt="American Express" className="me-2" />
            <img src={maestro} width="32" alt="Maestro" className="me-2" />
            <img src={netbanking} width="32" alt="Net Banking" className="me-2" />
            <img src={paypal} width="32" alt="Paypal" className="me-2" />
            <img src={rupay} width="32" alt="Rupay" className="me-2" />
            <img src={upi} width="32" alt="UPI" className="me-2" />
            <img src={visa} width="32" alt="Visa" className="me-2" />
          </div>
        </div>
      </div>
    </footer>
  </>
);

export default Footer;
